/**
 * The items list's intake-quarantine filter (`?review=`), shared by the
 * page that reads it and the header actions that carry it on (Export
 * view…, Share this view).
 */

/**
 * The `?review=` values the API takes (keepr-api utils/itemUtils REVIEW_FILTERS).
 * `accepted-by-rule` (KPR-482): what a public form's review RULE accepted with
 * nobody reading it — the API narrows it to what the caller could write.
 */
export const REVIEW_FILTERS = ['pending', 'accepted', 'any', 'accepted-by-rule'];

/** What each review filter is called where the list says it out loud. */
export const REVIEW_LABELS = {
	pending: 'Needs review',
	accepted: 'Accepted submissions',
	any: 'Including submissions waiting for review',
	'accepted-by-rule': 'Accepted by a rule',
};
